// 🔥 GLOBAL CACHE BUSTER: 
// Change this string (e.g., to "v2", "v3") ANY time you want to instantly wipe 
// the cache for every single user on the platform.
const CACHE_VERSION = "v2"; 

// ⏳ TIME TO LIVE: How long data stays fresh (e.g., 5 minutes = 300000 ms)
const CACHE_TTL_MS = 5 * 60 * 1000; 

export const getCachedData = (key) => {
    const versionedKey = `${CACHE_VERSION}_${key}`;

    try {
        const cached = localStorage.getItem(versionedKey);

        if (!cached) return null;

        const parsed = JSON.parse(cached);

        // 🛡️ FIX 1: Auto-Expiration Check
        // If the current time minus the saved time is greater than our TTL, destroy it!
        if (Date.now() - parsed.timestamp > CACHE_TTL_MS) {
            localStorage.removeItem(versionedKey);
            return null;
        }

        return parsed.data;
    } catch {
        // 🛡️ FIX 2: Corruption Shield
        // If JSON.parse fails because of bad data (like an HTML string), delete the bad data instantly.
        localStorage.removeItem(versionedKey);
        return null;
    }
};

export const setCachedData = (key, data) => {
    const versionedKey = `${CACHE_VERSION}_${key}`;

    try {
        localStorage.setItem(
            versionedKey,
            JSON.stringify({
                data,
                timestamp: Date.now()
            })
        );
    } catch (err) {
        console.error("Failed to save to cache", err);
    }
};